var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "order-btn" },
        [
          _c(
            "vxe-button",
            {
              on: {
                click: function ($event) {
                  return _vm.returnFun()
                },
              },
            },
            [_vm._v("返回")]
          ),
        ],
        1
      ),
      _c("a-divider"),
      _c("div", { staticClass: "orderFormLine" }, [_vm._v("订单信息")]),
      _c(
        "div",
        { staticClass: "budgetBox" },
        [
          _c(
            "a-form",
            {
              ref: "orderForm",
              staticClass: "UniformCss",
              attrs: { inline: true, model: _vm.order, "label-width": "100px" },
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: { label: "订单编号", prop: "applyOrderCode" },
                        },
                        [
                          _c("a-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.order.applyOrderCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "applyOrderCode", $$v)
                              },
                              expression: "order.applyOrderCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "申领部门", prop: "orgName" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.order.orgName,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "orgName", $$v)
                              },
                              expression: "order.orgName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "申领人", prop: "applyMan" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.order.applyMan,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "applyMan", $$v)
                              },
                              expression: "order.applyMan",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "申领日期", prop: "applyTime" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.order.applyTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "applyTime", $$v)
                              },
                              expression: "order.applyTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "订单总项数",
                            prop: "orderMaterialCount",
                          },
                        },
                        [
                          _c("a-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.order.orderMaterialCount,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "orderMaterialCount", $$v)
                              },
                              expression: "order.orderMaterialCount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "订单总数量", prop: "orderNums" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.order.orderNums,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "orderNums", $$v)
                              },
                              expression: "order.orderNums",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "订单总金额",
                            prop: "orderTotalSums",
                          },
                        },
                        [
                          _c("a-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.order.orderTotalSums,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "orderTotalSums", $$v)
                              },
                              expression: "order.orderTotalSums",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "审批数量", prop: "approveNums" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.order.approveNums,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "approveNums", $$v)
                              },
                              expression: "order.approveNums",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "审批总金额" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.order.approveTotalSums,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "approveTotalSums", $$v)
                              },
                              expression: "order.approveTotalSums",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "收货人", prop: "receiverName" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.order.receiverName,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "receiverName", $$v)
                              },
                              expression: "order.receiverName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "收货人联系方式",
                            prop: "receivePhone",
                          },
                        },
                        [
                          _c("a-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.order.receivePhone,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "receivePhone", $$v)
                              },
                              expression: "order.receivePhone",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "收货地址" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.order.address,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "address", $$v)
                              },
                              expression: "order.address",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "orderFormLine" }, [_vm._v("物料信息")]),
      _c(
        "div",
        [
          _c(
            "vxe-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.materialList,
                border: "",
                "show-header-overflow": "",
                "show-overflow": "",
                "header-cell-style": { background: "#eef1f6" },
              },
            },
            [
              _c("vxe-table-column", {
                attrs: {
                  field: "materialCode",
                  title: "物料号",
                  width: "150",
                  align: "center",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "materialName",
                  title: "物料名称",
                  width: "250",
                  align: "center",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "storage",
                  title: "库存量",
                  width: "90",
                  align: "center",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "price",
                  title: "申领价",
                  width: "90",
                  align: "center",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "nums",
                  title: "申领数量",
                  width: "90",
                  align: "center",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "totalSums",
                  title: "申领总金额",
                  width: "90",
                  align: "center",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "approveNums",
                  title: "审批数量",
                  width: "90",
                  align: "center",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "approveTotalSums",
                  title: "审批总金额",
                  width: "90",
                  align: "center",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "applyRemarks",
                  title: "申领备注",
                  width: "160",
                  align: "center",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  title: "操作",
                  align: "center",
                  fixed: "right",
                  width: "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "a-button",
                          {
                            attrs: { size: "small", type: "link" },
                            on: {
                              click: function ($event) {
                                return _vm.detailFun(row)
                              },
                            },
                          },
                          [_vm._v("查看")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("ApproveMaterialDialog", {
            attrs: {
              visible: _vm.dialogVisible,
              orderMaterial: _vm.rowMaterial,
              pictures: _vm.picList,
              isdetail: true,
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogVisible = $event
              },
              "update:orderMaterial": function ($event) {
                _vm.rowMaterial = $event
              },
              "update:order-material": function ($event) {
                _vm.rowMaterial = $event
              },
              close: _vm.close,
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "el-collapse",
            {
              staticClass: "collapse-box",
              staticStyle: { "margin-bottom": "10px" },
              model: {
                value: _vm.collapseNumber,
                callback: function ($$v) {
                  _vm.collapseNumber = $$v
                },
                expression: "collapseNumber",
              },
            },
            [
              _c(
                "el-collapse-item",
                {
                  staticClass: "collapseItem",
                  attrs: { title: "提报审核历史", name: "default" },
                },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.findHistTasksData,
                        loading: _vm.approveLoading,
                        border: "",
                        stripe: "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "displayName", label: "审核部门" },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "operatorName", label: "审核人" },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "finishTime", label: "审核时间" },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "amounts",
                          label: "申请费用(元)",
                          align: "right",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                row.amounts
                                  ? _c("span", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("toThousandNumFilter")(
                                              row.amounts
                                            )
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "approveCost",
                          label: "审核费用(元)",
                          align: "right",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                row.approveCost
                                  ? _c("span", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("toThousandNumFilter")(
                                              row.approveCost
                                            )
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "operateType", label: "操作类型" },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "approveMsg", label: "审核意见" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }